import React, { useEffect, useState } from "react";

const launchDate = new Date("2025-06-20T05:00:00-05:00").getTime();

const getTimeRemaining = () => {
  const now = new Date().getTime();
  const distance = launchDate - now;

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  return {
    total: distance,
    days,
    hours,
    minutes,
    seconds,
  };
};

const CountdownBox = ({ value, label }) => (
  <div className="flex flex-col items-center w-20 p-2 rounded-xl bg-gradient-to-b from-blue-900 to-purple-900 shadow-md">
    <div className="text-3xl font-bold text-white drop-shadow-sm">{value}</div>
    <div className="text-sm text-white uppercase tracking-wide mt-1">{label}</div>
  </div>
);

export default function CoinDropCountdown() {
  const [timeLeft, setTimeLeft] = useState(getTimeRemaining());

  useEffect(() => {
    const timer = setInterval(() => {
      const updatedTime = getTimeRemaining();
      setTimeLeft(updatedTime);

      if (updatedTime.total <= 0) {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (timeLeft.total <= 0) {
    return (
      <div className="bg-black text-white p-8 rounded-2xl shadow-lg text-center mx-auto max-w-md">
        <div className="text-2xl font-bold">🚀 Coin Dropped! Let's Go!</div>
      </div>
    );
  }
// bg-gradient-to-br
  return (
<div className="flex flex-col items-end justify-end rounded-2xl shadow-lg max-w-full md:max-w-[25%]  shadow-lg overflow-hidden from-gray-400 to-gray-900 px-4 py-3 w-full">
{
//      <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-8 drop-shadow-md">
//        SharkKid SK Coin Drop
//      </h1>
}
      <div className="flex gap-4 md:gap-6">
        <CountdownBox value={timeLeft.days} label="Days" />
        <CountdownBox value={timeLeft.hours} label="Hours" />
        <CountdownBox value={timeLeft.minutes} label="Minutes" />
        <CountdownBox value={timeLeft.seconds} label="Seconds" />
      </div>
    </div>
  );
}
